import { useEffect, useState } from "react";
import GroupUsersRequests from "../../../../../Services/Api/GroupUsersRequests.ts";
import AddUserModal from "./Components/AddUserModal/AddUserModal.js";
import ScrollableList from "../../../../../Components/ScrollableList/ScrollableList.js";
import { GetPermissionsToDisplay } from "../../../../../Services/Permissions/PermissionManager.js";
import ScpPermissions from "../../../../../Services/Permissions/Data/ScpPermissions.js";
import { MdEdit } from "react-icons/md";
import EditUserModal from "./Components/EditUserModal/EditUserModal.js";

const GroupUsers = ({groupId, group}) => {
    const groupUsersRequest = new GroupUsersRequests();

    const[groupUsers, setGroupUsers] = useState(null);
    const [showAddUser, setShowAddUser] = useState(false);

    const [editUser, setEditUser] = useState(null);

    useEffect(() => {
        refresh();
    }, [groupId])

    const processGroupUsers = (groupUserData) => {
        const mapedData = groupUserData.map((groupUser) => {
            return {
                id: groupUser.id,
                columns: [
                    <div className="flex gap-32">
                        <p className="w-12">{groupUser.panelUser.login}</p>
                        <div>
                            <h3>Uprawnienia</h3>
                            <div className="columns-4 bg-glgray-600 p-3 rounded-xl">
                                <GetPermissionsToDisplay permissionsData={ScpPermissions} permissions={groupUser.permissions}/>
                            </div>
                        </div>
                    </div>
                ],
                text: groupUser.panelUser.login,
                userId : groupUser.userId,
                groupUser: groupUser
        }})

        setGroupUsers(mapedData)
    };

    const refresh = () => {
        groupUsersRequest.GetForGroup(groupId, processGroupUsers);
    }

    const removeFunction = (id) => {
        groupUsersRequest.Delete(id, () => {refresh()})
    }

    const edit = (data) => {
        setEditUser(data);
    }

    if(!groupUsers)
        return (<></>);

    return (            
        <>
            <ScrollableList 
                setShowAdd={setShowAddUser}
                removeFunction={removeFunction}
                refresh={() => refresh()}
                title={"Użytkownicy"}
                customButtons={[{ icon: <MdEdit size={"22px"} className="iconBtn"/>, onClick: (data) => {edit(data.groupUser)} }]}
                data={groupUsers}
                listClass={"overflow-y-auto overflow-x-hidden max-h-[55vh]"}
                removeTitle={"Usuń użytkownika z grupy"}
            />
            { editUser &&
                <EditUserModal editUser={editUser} hide={() => setEditUser(null)} refresh={() => refresh()} />
            }
            { showAddUser &&
                <AddUserModal groupId={groupId} groupUsers={groupUsers} refresh={refresh} hide={() => setShowAddUser(false)}/>
            }            
        </>
    )
}

export default GroupUsers;